require('../../modules/es7.object.get-own-property-descriptors');
module.exports = require('../../modules/_core').Object.getOwnPropertyDescriptors;



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/fn/object/get-own-property-descriptors.js